import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppFloat.css";

const WhatsAppFloat = ({ productInfo }) => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "+917567288345";
    
    let message = `Hi! I'm interested in your products. Can you help me with more information?`
    
    // If product info is available, create a more specific message
    if (productInfo && productInfo.name) {
      message = `Hi! I'm interested in this product: ${productInfo.name}`;
      
      if (productInfo.url) {
        message += `\nProduct Link: ${productInfo.url}`;
      }
      
      message += "\nCan you provide more details about this product?";
    }
    
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <FaWhatsapp className="whatsapp-icon" />
    </div>
  );
};

export default WhatsAppFloat;
